import * as React from "react";

function CheckboxIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      {...props}
    >
      <g data-name="check (1)" fill={props.fill}>
        <path
          data-name="Path 5840"
          d="M13.124 4.96a.874.874 0 00-.875.875v6.416H1.75V1.752h6.416a.875.875 0 100-1.75H.875A.874.874 0 000 .877v12.249a.874.874 0 00.875.875h12.249a.874.874 0 00.875-.875V5.835a.874.874 0 00-.875-.875z"
        />
        <path
          data-name="Path 5841"
          d="M12.432.271L6.458 6.247 4.197 3.986a.92.92 0 10-1.3 1.3L5.81 8.19a.915.915 0 001.3 0l6.622-6.624a.92.92 0 00-1.3-1.3z"
        />
      </g>
    </svg>
  );
}

export default CheckboxIcon;
